import type { VariantProps } from 'tailwind-variants';
import { tv } from 'tailwind-variants';

export const toastStyles = tv({
  base: [
    'flex items-start justify-between gap-4',
    'p-3 min-w-xs',
    'shadow-lg rounded-md',
    'border-2 border-[var(--color)] bg-primary-contrast',
  ],
  variants: {
    variant: {
      neutral: '[--color:var(--color-secondary-500)]',
      info: '[--color:var(--color-blue-600)]',
      positive: '[--color:var(--color-green-600)]',
      warning: '[--color:var(--color-amber-600)]',
      negative: '[--color:var(--color-red-600)]',
    },
  },
});

export type ToastVariant = VariantProps<typeof toastStyles>['variant'];

export type ToastAction = {
  label: string;
  onPress: () => void;
};

export type ToastContent = {
  title?: string;
  description?: string;
  variant?: ToastVariant;
  /** Optional action button rendered beside the close button. */
  action?: ToastAction;
};
